import React from 'react';
import {View} from 'react-native';

import {Code, Heading, Spacer, Spacing} from '/component/base/Storybook';
import Text from '/component/base/Text';

import PercentageProgressListItem from '../PercentageProgressListItem';

import {styles} from './PercentageProgressListItem.style';

export default () => (
  <>
    <Spacing size={20}>
      <Heading level={2}>OneLineLayout</Heading>
      <Spacer size={16} />
      <Text>
        The <Code>{'oneLineLayout'}</Code> prop determines the layout of the
        list item. If true, the list item layout will be on a single line.
      </Text>
    </Spacing>
    <View style={styles.wrapper}>
      <PercentageProgressListItem
        hasCheckbox
        label={<Text>Group Qualifying Volume</Text>}
        readonly
        numerator={10}
        denominator={25}
        oneLineLayout
      />
    </View>
    <Spacing size={20}>
      <Code>{'oneLineLayout={true}'}</Code>
    </Spacing>
  </>
);
